module.exports = __webpack_public_path__ + "img/logo-with-grad.e813db46.png";